import React from 'react';
import { ChatMessage } from './ChatTypes';
import { CreateMessage } from './UseChat';

export const AssistantContext = React.createContext({
    messages: [] as ChatMessage[],
    addToolResult: (_toolCallId: string, _result: any) => false as boolean,
    append: (_message: CreateMessage) => { },
    submit: () => { },
    submitMessage: (_text: string) => { },
    submitToolResult: (_toolCallId: string, _result: any) => { },
});
